import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackCianDobroBannerClick, trackCianDobroBannerShow } from './tracking';
import { useApplicationContext } from '../../../utils/applicationContext';
import { CianDobroBanner } from '../../components/CianDobroBanner';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

type TCianDobroBannerInfo = {
  header: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
  logoUrl: string;
};

export function CianDobroBannerContainer() {
  const { config } = useApplicationContext();
  const bannerInfo = config.get<TCianDobroBannerInfo>('cian-dobro.desktopSerpBannerInfo');

  const jsonQuery = useSelector(getJsonQuery);

  const handleClick = React.useCallback(() => {
    trackCianDobroBannerClick(jsonQuery);
  }, [jsonQuery]);

  const handleShow = React.useCallback(() => {
    trackCianDobroBannerShow(jsonQuery);
  }, [jsonQuery]);

  if (
    !bannerInfo ||
    !bannerInfo.header ||
    !bannerInfo.text ||
    !bannerInfo.buttonText ||
    !bannerInfo.buttonUrl ||
    !bannerInfo.logoUrl
  ) {
    return null;
  }

  return <CianDobroBanner {...bannerInfo} onShow={handleShow} onClick={handleClick} />;
}
